module.exports = __webpack_public_path__ + "img/done_light.7904e969.svg";